import { api } from "@/lib/api";

const STORAGE_KEY = "shoptosa_graph_click";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

/** Remember the Graph API click id from a tracked buy link (?click=clk_…). */
export function rememberClick(search) {
  const id = new URLSearchParams(search).get("click");
  if (!id || !/^clk_[a-f0-9]{8,32}$/.test(id)) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ id, at: Date.now() }));
  } catch {
    /* storage unavailable */
  }
}

/** Attach the remembered click to the signed-in shopper's bag so the sale credits the developer. */
export async function applyClickToCart() {
  let saved = null;
  try {
    saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    saved = null;
  }
  if (!saved?.id) return;
  if (Date.now() - Number(saved.at || 0) > MAX_AGE_MS) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  try {
    await api.post("/cart/attribution", { click_id: saved.id });
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* retry on the next cart visit */
  }
}
